import BybVrDialog from "@Components/game/common/dialog/byb-vr-dialog";
import Icon from "@Components/generic/icon";
import { faBolt } from "@fortawesome/pro-solid-svg-icons";
import useI18n from "@i18n";
import { Stack, Typography, useTheme } from "@mui/material";

interface IBetaLearnMoreDialog {
  open: boolean;
  onClose: () => void;
}

const BetaLearnMoreDialog = ({ open, onClose }: IBetaLearnMoreDialog) => {
  const { i18n } = useI18n();
  const theme = useTheme();

  return (
    <BybVrDialog
      name="beta-learn-more"
      open={open}
      onClose={onClose}
      width="30vw"
      showCloseButton
    >
      <Stack spacing={3} alignItems="center" textAlign="center" padding={2}>
        <Stack
          alignItems="center"
          justifyContent="center"
          sx={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            backgroundColor: `${theme.palette.dsWarning.v400}15`,
          }}
        >
          <Icon icon={faBolt} color={theme.palette.dsWarning.v400} size="xl" />
        </Stack>

        <Stack spacing={3} alignItems="center" padding={theme.spacing(0, 6, 6, 6)}>
          <Typography variant="text5xl700" color="dsBase.v200">
            {i18n("session-results.beta-dialog.title")}
          </Typography>

          <Typography variant="text1xl500" color="dsNeutral.v300">
            {i18n("session-results.beta-dialog.p1")}
          </Typography>

          <Typography variant="text1xl500" color="dsNeutral.v300">
            {i18n("session-results.beta-dialog.p2")}
          </Typography>

          <Typography variant="text1xl700" color="dsNeutral.v300">
            {i18n("session-results.beta-dialog.footer")}
          </Typography>
        </Stack>
      </Stack>
    </BybVrDialog>
  );
};

export default BetaLearnMoreDialog;
